export function buildClientDeepLink(clientId: string, insightId: string): string {
  const c = encodeURIComponent(clientId ?? '');
  const i = encodeURIComponent(insightId ?? '');
  return `clients/${c}/overview?insightId=${i}`;
}

export function parseClientDeepLink(pathOrUrl: string): {
  clientId?: string;
  subview?: 'overview' | 'programs' | 'profile';
  insightId?: string;
} {
  if (!pathOrUrl) return {};

  // Normalize into path + search (no origin required)
  let pathWithSearch = pathOrUrl;
  try {
    const url = new URL(pathOrUrl, 'http://localhost');
    pathWithSearch = `${url.pathname}${url.search || ''}`;
  } catch {
    // keep as-is
  }

  // Accept optional leading and trailing slash; only overview route is supported
  const match = pathWithSearch.match(/^\/?clients\/([^/]+)\/overview\/?(?:\?(.*))?$/);
  if (!match) return {};

  const clientId = decodeURIComponent(match[1]);
  const query = new URLSearchParams(match[2] || '');
  const rawInsight = query.get('insightId') || '';
  const insightId = rawInsight ? decodeURIComponent(rawInsight) : undefined;

  return { clientId, subview: 'overview', insightId };
}
